import './tracker';

declare global {
  interface Window {
    TRACKER_HOSTS?: string[];
  }
}

// eslint-disable-next-line no-console
console.log('[cdn-testbed] booted; tracker armed; loading static assets…');

function init(): void {
  const hostsEl = document.getElementById('hosts');
  if (hostsEl) {
    hostsEl.textContent = JSON.stringify([
      location.host,
      ...(window.TRACKER_HOSTS ?? []),
    ]);
  }

  // Same-origin: wasm via fetch (initiator: fetch)
  void fetch('/static/module.wasm').then((r) => r.arrayBuffer());

  const cdnHost = (window.TRACKER_HOSTS ?? [])[0];
  if (!cdnHost) return;

  const block = document.getElementById('cdn-block');
  if (block) block.textContent = '';

  // ВАЖНО: для cross-origin элементов выставляем crossorigin="anonymous".
  // Без этого Safari прячет transferSize / encodedBodySize / serverTiming на
  // cross-origin Resource Timing, даже при наличии Timing-Allow-Origin. Chrome
  // не требует, но и не ломается.

  const css = document.createElement('link');
  css.rel = 'stylesheet';
  css.crossOrigin = 'anonymous';
  css.href = `https://${cdnHost}/static/styles.css?o=cdn`;
  document.head.appendChild(css);

  for (const name of ['small.js', 'big.js']) {
    const s = document.createElement('script');
    s.type = 'module';
    s.crossOrigin = 'anonymous';
    s.src = `https://${cdnHost}/static/${name}?o=cdn`;
    document.head.appendChild(s);
  }

  for (const name of ['tiny.png', 'medium.jpg']) {
    const img = document.createElement('img');
    img.crossOrigin = 'anonymous';
    img.src = `https://${cdnHost}/static/${name}?o=cdn`;
    img.width = 64;
    block?.appendChild(img);
  }

  // wasm via fetch (mode: 'cors' is default for cross-origin)
  void fetch(`https://${cdnHost}/static/module.wasm?o=cdn`, {
    mode: 'cors',
  }).then((r) => r.arrayBuffer());
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
